// frontend/src/modules/public/pages/EncerrarEmpresa.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaCheck, FaLock, FaUserPlus } from 'react-icons/fa';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

function EncerrarEmpresa() {
  const navigate = useNavigate();
  const [jaECliente, setJaECliente] = useState(null); // null, true, false
  const [formData, setFormData] = useState({
    nome_completo: '',
    email: '',
    telefone: '',
    cnpj_encerrar: '',
    motivo_encerrar: '',
    mensagem: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_URL}/api/leads/encerramento`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...formData,
          ja_e_cliente: jaECliente
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Erro ao enviar solicitação');
      }

      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // ============================================
  // ESTILOS
  // ============================================
  const styles = {
    container: {
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1a237e 0%, #4a90e2 100%)',
      padding: '40px 20px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    },
    card: {
      maxWidth: '700px',
      margin: '0 auto',
      background: 'white',
      borderRadius: '16px',
      padding: '40px',
      boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
    },
    backButton: {
      background: 'none',
      border: 'none',
      color: '#6c757d',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      marginBottom: '20px',
      fontSize: '14px'
    },
    title: {
      fontSize: '28px',
      fontWeight: 'bold',
      color: '#1a237e',
      marginBottom: '10px'
    },
    subtitle: {
      color: '#6c757d',
      marginBottom: '30px',
      fontSize: '14px'
    },
    questionBox: {
      display: 'flex',
      flexDirection: 'column',
      gap: '15px',
      marginTop: '30px'
    },
    optionButton: {
      padding: '25px',
      border: '2px solid #e9ecef',
      borderRadius: '12px',
      background: 'white',
      cursor: 'pointer',
      textAlign: 'left',
      transition: 'all 0.2s',
      display: 'flex',
      alignItems: 'center',
      gap: '15px'
    },
    optionIcon: {
      fontSize: '32px'
    },
    optionTitle: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#1a237e',
      marginBottom: '5px'
    },
    optionDesc: {
      fontSize: '14px',
      color: '#6c757d'
    },
    formGroup: {
      marginBottom: '20px'
    },
    label: {
      display: 'block',
      marginBottom: '8px',
      fontWeight: '500',
      color: '#212529',
      fontSize: '14px'
    },
    input: {
      width: '100%',
      padding: '12px 15px',
      border: '1px solid #ddd',
      borderRadius: '8px',
      fontSize: '14px',
      boxSizing: 'border-box'
    },
    button: {
      width: '100%',
      padding: '15px',
      background: '#dc3545',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      marginTop: '20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '10px'
    },
    buttonBack: {
      width: '100%',
      padding: '15px',
      background: '#6c757d',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      marginTop: '10px'
    },
    error: {
      background: '#ffebee',
      color: '#c62828',
      padding: '15px',
      borderRadius: '8px',
      marginBottom: '20px',
      fontSize: '14px'
    },
    successContainer: {
      textAlign: 'center',
      padding: '60px 20px'
    },
    successIcon: {
      fontSize: '80px',
      marginBottom: '20px'
    },
    successTitle: {
      fontSize: '28px',
      fontWeight: 'bold',
      color: '#28a745',
      marginBottom: '15px'
    },
    successText: {
      color: '#6c757d',
      marginBottom: '30px',
      fontSize: '16px'
    }
  };

  // ============================================
  // TELA DE SUCESSO
  // ============================================
  if (success) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.successContainer}>
            <div style={styles.successIcon}>✅</div>
            <h2 style={styles.successTitle}>Solicitação Registrada!</h2>
            <p style={styles.successText}>
              {jaECliente
                ? 'Sua solicitação foi registrada e um chamado foi aberto. Nossa equipe entrará em contato em breve.'
                : 'Entraremos em contato em até 24 horas úteis para dar continuidade ao processo.'}
            </p>
            <button
              style={{ ...styles.button, maxWidth: '300px', margin: '30px auto 0', background: '#28a745' }}
              onClick={() => navigate('/')}
            >
              Voltar para Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  // ============================================
  // TELA DE LOGIN (para quem já é cliente)
  // ============================================
  if (jaECliente === true && !formData.nome_completo) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <button style={styles.backButton} onClick={() => setJaECliente(null)}>
            <FaArrowLeft /> Voltar
          </button>

          <h1 style={styles.title}>🔐 Acesse o Sistema</h1>
          <p style={styles.subtitle}>
            Faça login para abrir um chamado de encerramento. Nossa equipe dará andamento.
          </p>

          <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <button
              style={{ ...styles.button, background: '#4a90e2' }}
              onClick={() => navigate('/login')}
            >
              <FaLock /> Fazer Login
            </button>
            <p style={{ marginTop: '20px', color: '#6c757d', fontSize: '14px' }}>
              Não é cliente ainda?{' '}
              <a
                style={{ color: '#4a90e2', cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => setJaECliente(false)}
              >
                Clique aqui
              </a>
            </p>
          </div>
        </div>
      </div>
    );
  }

  // ============================================
  // FORMULÁRIO DE ENCERRAMENTO
  // ============================================
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <button style={styles.backButton} onClick={() => navigate('/')}>
          <FaArrowLeft /> Voltar para Home
        </button>

        <h1 style={styles.title}>🚪 Encerrar Empresa</h1>
        <p style={styles.subtitle}>
          Vamos te ajudar a encerrar sua empresa de forma rápida e segura.
        </p>

        {/* PERGUNTA INICIAL */}
        {jaECliente === null && (
          <div style={styles.questionBox}>
            <h3 style={{ color: '#1a237e', marginBottom: '10px' }}>
              Você já é cliente da Contábil?
            </h3>

            <button
              style={styles.optionButton}
              onClick={() => setJaECliente(true)}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#4a90e2';
                e.currentTarget.style.background = '#f0f7ff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#e9ecef';
                e.currentTarget.style.background = 'white';
              }}
            >
              <span style={styles.optionIcon}>✅</span>
              <div>
                <div style={styles.optionTitle}>Sim, já sou cliente</div>
                <div style={styles.optionDesc}>
                  Faça login e abra um chamado de encerramento
                </div>
              </div>
            </button>

            <button
              style={styles.optionButton}
              onClick={() => setJaECliente(false)}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#4a90e2';
                e.currentTarget.style.background = '#f0f7ff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#e9ecef';
                e.currentTarget.style.background = 'white';
              }}
            >
              <span style={styles.optionIcon}><FaUserPlus /></span>
              <div>
                <div style={styles.optionTitle}>Não, ainda não sou cliente</div>
                <div style={styles.optionDesc}>
                  Preencha o formulário e entraremos em contato
                </div>
              </div>
            </button>
          </div>
        )}

        {/* FORMULÁRIO PARA NÃO-CLIENTE */}
        {jaECliente === false && (
          <form onSubmit={handleSubmit} style={{ marginTop: '30px' }}>
            {error && <div style={styles.error}>❌ {error}</div>}

            <div style={styles.formGroup}>
              <label style={styles.label}>Nome Completo *</label>
              <input
                name="nome_completo"
                value={formData.nome_completo}
                onChange={handleChange}
                required
                style={styles.input}
                placeholder="Digite seu nome completo"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Email *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                style={styles.input}
                placeholder="seu@email.com"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Telefone/WhatsApp</label>
              <input
                name="telefone"
                value={formData.telefone}
                onChange={handleChange}
                style={styles.input}
                placeholder="(11) 99999-9999"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>CNPJ da Empresa a Encerrar *</label>
              <input
                name="cnpj_encerrar"
                value={formData.cnpj_encerrar}
                onChange={handleChange}
                required
                style={styles.input}
                placeholder="00.000.000/0001-00"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Motivo do Encerramento</label>
              <select
                name="motivo_encerrar"
                value={formData.motivo_encerrar}
                onChange={handleChange}
                style={styles.input}
              >
                <option value="">Selecione...</option>
                <option value="FALENCIA">Falência / Encerramento de atividades</option>
                <option value="MUDANCA_CONTADOR">Mudança de contador</option>
                <option value="ABERTURA_OUTRA">Abertura de outra empresa</option>
                <option value="APOSENTADORIA">Aposentadoria</option>
                <option value="OUTRO">Outro motivo</option>
              </select>
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Mensagem (opcional)</label>
              <textarea
                name="mensagem"
                value={formData.mensagem}
                onChange={handleChange}
                rows="4"
                style={{ ...styles.input, resize: 'vertical' }}
                placeholder="Conte-nos mais sobre sua situação..."
              />
            </div>

            <button type="submit" disabled={loading} style={styles.button}>
              {loading ? '⏳ Enviando...' : <><FaCheck /> Solicitar Encerramento</>}
            </button>

            <button
              type="button"
              style={styles.buttonBack}
              onClick={() => setJaECliente(null)}
            >
              ← Voltar
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default EncerrarEmpresa;